// extracted by mini-css-extract-plugin
module.exports = {"twoStepTableHeader":"ReportHealthInsuranceBonusTable__twoStepTableHeader--3pvXz","rectangle":"ReportHealthInsuranceBonusTable__rectangle--1ha5C"};